import styled from 'styled-components'
import {colors} from '../../../styles/theme'

export const FlahshcardBox = styled.div`
  margin-top: 24px;
`

export const ObjectiveText = styled.p`
  margin: 0;
  padding: 0;
  font-size: 14px;
  color: ${colors.bksGray80};
  margin-top: 20px;
  font-style: italic;
`
